import React from 'react';
import { Spinner } from 'react-bootstrap';

function SpinnerComponent({style={}}={}) {
  return (
    <Spinner animation="border" style={{...{ width: '4rem', height: '4rem',position:'relative', color: '#0D6EFD' },...style}}>
      <span className="visually-hidden">Loading...</span>
    </Spinner>
  );
}

export default SpinnerComponent;
